// import { Component } from '@angular/core';
// import {
//   ActivatedRoute,
//   NavigationEnd,
//   NavigationStart,
//   RouteConfigLoadEnd,
//   RouteConfigLoadStart,
//   Router,
// } from '@angular/router';
// import { environment } from 'src/environments/environment';
// import { Unsubscribe } from './services/unsubscribe.class';
// import { LoadingService } from './services/loading.service';
// import { UtilsService } from './services/utils.service';
// import { MallAuthenticationService } from './mall/services/mall-auth.service';

// @Component({
//   selector: 'app-root',
//   templateUrl: 'app.component.html',
//   styleUrls: ['app.component.scss'],
// })
// export class AppComponent {
//   public isLoading$ = this.loadingService.loading$;
//   baseUrl = environment.baseUrl;
//   showMallIframe = false;

//   constructor(
//     public router: Router,
//     private route: ActivatedRoute,
//     private utils: UtilsService,
//     private mallAuthService: MallAuthenticationService,
//     private loadingService: LoadingService
//   ) {
//     console.log(router)
//     // Spinner for lazyload modules
//     router.events.forEach((event) => {
//       if (
//         event instanceof NavigationStart ||
//         event instanceof RouteConfigLoadStart
//       ) this.loadingService.showLoading();
//       if (event instanceof NavigationEnd || event instanceof RouteConfigLoadEnd) this.loadingService.hideLoading();
//     });

//     this.handleAuthorization()
//     this.utils.setDefaultTheme();

//   }
//   // async goToMall() {
//   //   const isAuthenticated = await this.mallAuthService.isAuthenticated();
//   //   if (isAuthenticated) {
//   //     window.location.href = 'https://mall.payarena.com/';
//   //   } else {
//   //     await this.utils.presentToast('Authenticating your access to this page, if this message persists please sign in again');
//   //     await this.loadingService.hideLoading(); // Fixed: loader -> loadingService
//   //     this.router.navigate(['coming-soon']);
//   //   }
//   // }

//   //   goToMall() {
//   //   window.location.href = 'https://mall.payarena.com/';
//   // }

//   hideIframe() {
//     this.showMallIframe = false; // Hide iframe when switching tabs
//   }

//   onTabChange(event: any) {
//   const nextTab = event.tab;

//   if (nextTab !== 'mall') {
//     this.hideIframe(); // Hide iframe whenever leaving mall
//   }
// }

//   onIframeLoad() {
//     this.loadingService.hideLoading(); // Hide loader when iframe loads
//   }

//  async goToMall() {
//   this.loadingService.showLoading();

//   try {
//     const isAuthenticated = await this.mallAuthService.isAuthenticated();

//     if (isAuthenticated) {
//       // ✅ Authenticated: show mall iframe
//       this.showMallIframe = true;
//       this.loadingService.hideLoading();
//       // (iframe will also hide loader on load via onIframeLoad)
//     } else {
//       // ❌ Not authenticated: leave router-outlet visible
//       this.loadingService.hideLoading();
//       await this.utils.presentToast(
//         'Authenticating your access to this page, if this message persists please sign in again'
//       );
//       this.router.navigate(['coming-soon']);
//     }
//   } catch (error) {
//     this.loadingService.hideLoading();
//     console.error('Authentication error:', error);
//     await this.utils.presentToast(
//       'Authentication failed. Please sign in again.'
//     );
//     this.router.navigate(['coming-soon']);
//   }
// }

// //   async goToMall() {
// //   this.loadingService.showLoading();
// //   this.showMallIframe = true;
// // }

//   handleAuthorization() {
//     // this.authenticateMallUser('leyeshalom@gmail.com',  'Shalom17.');
//     this.route.queryParams.subscribe((paramsData: any) => {
//       console.log(this.route)
//       const { data }: any = paramsData;

//       if (data) {
//         const userData = JSON.parse(data);
//         console.log('User: ', userData);

//         const { theme, token, credentials } = userData;

//         this.utils.setTheme(theme);
//         if (token) localStorage.setItem(this.utils.STORAGE_KEYS.TOKEN, token);
//         // if(credentials) this.authenticateMallUser(credentials?.username, credentials?.password);
//       }
//     });
//   }

//   authenticateMallUser(email: string, password: string) {
//     console.log({ email, password })
//     this.mallAuthService.login({ email: 'leyeshalom@gmail.com', password: 'Shalom17.' }).subscribe({
//       next: () => console.log('Mall access has been authorized'),
//     });
//   }
// }

import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoadingService } from './services/loading.service';
import { UtilsService } from './services/utils.service';
import { MallAuthenticationService } from './mall/services/mall-auth.service';
import { ActiveTabService } from './services/ActiveTab.service';
import { TokenRefreshService } from './services/token-refresh.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  activeTab$ = this.activeTabService.activeTab$;
  public isLoading$ = this.loadingService.loading$;
  baseUrl = environment.baseUrl;
  showMallIframe = false;
  private mallIframeWindow: Window | null = null;
  private mallIframeOrigin: string | null = null;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private utils: UtilsService,
    // private mallAuthService: MallAuthenticationService,
    private loadingService: LoadingService,
    private activeTabService: ActiveTabService,
    private tokenRefreshService: TokenRefreshService,
  ) {
    // Spinner for lazyload modules
    router.events.forEach((event) => {
      const isCreateWalletRoute = this.isCreateWalletNavigation(event);
      if (
        (event instanceof NavigationStart ||
          event instanceof RouteConfigLoadStart) &&
        !isCreateWalletRoute
      ) {
        this.loadingService.showLoading();
      }
      if (
        event instanceof NavigationEnd ||
        event instanceof RouteConfigLoadEnd
      ) {
        this.loadingService.hideLoading();
      }
    });

    this.handleAuthorization();
    this.tokenRefreshService.start();
    this.utils.setDefaultTheme();
    this.activeTabService.activeTab$.subscribe((tab) => {
      if (tab === 'mall') this.showMallIframe = true;
    });
  }

  ngOnInit() {
    // Parent listens for iframe messages
    window.addEventListener('message', this.handleIframeMessage.bind(this));
    // this.mallAuthService.init();
    // this.authenticateMallUser('leyeshalom@gmail.com', 'Shalom17.');
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleIframeMessage.bind(this));
    // this.mallAuthService.destroy();
  }

  handleIframeMessage(event: MessageEvent) {
    console.log('📥 [Parent] Received message:', {
      origin: event.origin,
      data: event.data,
      source: event.source,
    });

    // Ignore React DevTools messages
    if (event.data?.source === 'react-devtools-content-script') {
      console.log('ℹ️ [Parent] Ignoring react-devtools message');
      return;
    }

    // MessageEvent.origin contains only scheme, host, and port (never a path
    // or trailing slash).
    const allowedOrigins = [
      'https://test.mall.payarena.com',
      'https://mall.payarena.com',
      'http://localhost:5173',
      'http://localhost:3000',
      'http://localhost:4200',
    ];
    const incomingOrigin = (() => {
      try {
        return new URL(event.origin).origin;
      } catch {
        return event.origin.trim().replace(/\/+$/, '');
      }
    })();
    if (!allowedOrigins.includes(incomingOrigin)) {
      console.warn(
        '🚫 [Parent] Message ignored due to origin mismatch:',
        incomingOrigin,
      );
      return;
    }

    const { type, data } = event.data || {};
    if (type === 'UPDATE_LOCAL_STORAGE' && data && typeof data === 'object') {
      const ALLOWED_UPDATE_KEYS = new Set([
        this.utils.STORAGE_KEYS.MALL_TOKEN,
        this.utils.STORAGE_KEYS.MALL_USER_INFO,
        'mall-token',
        'mallUserInfo',
        'ionic',
      ]);

      Object.entries(data).forEach(([key, value]) => {
        if (!ALLOWED_UPDATE_KEYS.has(key)) return;
        if (value) {
          console.log(`✅ [Parent] Setting localStorage[${key}] =`, value);
          const strVal = typeof value === 'object' ? JSON.stringify(value) : (value as string);
          localStorage.setItem(key, strVal);
        } else {
          localStorage.removeItem(key);
        }
      });
      console.log('📥 [Parent] Updated storage:', data);
    } else if (type === 'IFRAME_READY') {
      console.log('🚀 [Parent] Received IFRAME_READY, sending localStorage');
      this.mallIframeWindow = event.source as Window;
      this.mallIframeOrigin = event.origin;
      this.sendLocalStorageToIframe(this.mallIframeWindow, this.mallIframeOrigin);
    } else {
      console.warn('⚠️ [Parent] Unknown message type:', type);
    }
  }

  sendLocalStorageToIframe(targetWindow: Window, targetOrigin: string) {
    if (targetWindow) {
      const data = {
        [this.utils.STORAGE_KEYS.MALL_TOKEN]:
          localStorage.getItem(this.utils.STORAGE_KEYS.MALL_TOKEN) ||
          localStorage.getItem('mall-token') ||
          localStorage.getItem('token'),
        [this.utils.STORAGE_KEYS.MALL_USER_INFO]:
          localStorage.getItem(this.utils.STORAGE_KEYS.MALL_USER_INFO) ||
          localStorage.getItem('mallUserInfo'),
      };
      if (!data[this.utils.STORAGE_KEYS.MALL_TOKEN] &&
        !data[this.utils.STORAGE_KEYS.MALL_USER_INFO]) {
        console.info('[Parent] Mall data not ready; will sync when startup params arrive.');
        return;
      }
      console.log(
        '🚀 [Parent] Sending SYNC_LOCAL_STORAGE to:',
        targetOrigin,
        {
          hasMallToken: Boolean(data[this.utils.STORAGE_KEYS.MALL_TOKEN]),
          hasMallUserInfo: Boolean(data[this.utils.STORAGE_KEYS.MALL_USER_INFO]),
        },
      );
      targetWindow.postMessage(
        {
          type: 'SYNC_LOCAL_STORAGE',
          data: {
            ...data,
            ionic: true, // ✅ Add flag here
          },
        },
        targetOrigin,
      );
    } else {
      console.warn(
        '⚠️ [Parent] No iframe found or contentWindow not accessible',
      );
    }
  }

  hideIframe() {
    this.showMallIframe = false; // Hide iframe when leaving mall
  }

  onTabChange(event: any) {
    const nextTab = event.tab;
    // this.activeTabService.setActiveTab(nextTab);

    // if (nextTab !== 'mall') {
    //   this.hideIframe();
    //   this.router.navigate([nextTab]); // navigate to clicked tab
    // }

    if (nextTab !== 'mall') {
      this.hideIframe();
      this.router.navigate([nextTab]);
    } else {
      this.showMallIframe = true;
    }
  }

  onIframeLoad(event: Event) {
    this.loadingService.hideLoading(); // Hide loader when iframe loads
    const iframe = event.target as HTMLIFrameElement;
    const targetWindow = iframe.contentWindow;
    const targetOrigin = new URL(iframe.src).origin;
    if (targetWindow) {
      setTimeout(
        () => this.sendLocalStorageToIframe(targetWindow, targetOrigin),
        1000,
      );
    }
  }

  async goToMall() {
    this.loadingService.showLoading();
    // this.activeTabService.setActiveTab('mall');
    try {
      // const isAuthenticated = await this.mallAuthService.isAuthenticated();
      // if (isAuthenticated) {
      this.showMallIframe = true;
      this.loadingService.hideLoading();
      await this.router.navigate(['/mall']);
      // } else {
      //   // ❌ Not authenticated
      //   this.loadingService.hideLoading();
      //   await this.utils.presentToast(
      //     'Authenticating your access to this page, if this message persists please sign in again',
      //   );
      //   this.router.navigate(['coming-soon']);
      // }
    } catch (error) {
      this.loadingService.hideLoading();
      console.error('Authentication error:', error);
      await this.utils.presentToast(
        'Authentication failed. Please sign in again.',
      );
      this.router.navigate(['coming-soon']);
    }
  }

  handleAuthorization() {
    this.route.queryParams.subscribe((paramsData: any) => {
      const { data }: any = paramsData;
      // const mockData = {
      //   "theme": true,
      //   "token": "eyJhbGciOiJSUzI1NiIsImtpZCI6InBheWFyZW5hLWlkcC1yc2Eta2V5LXYxIiwidHlwIjoiSldUIn0.eyJpc3MiOiJodHRwczovL3Rlc3QuYXBpbWFsbC5wYXlhcmVuYS5jb20iLCJzdWIiOiJjOGFjNjlhOS1lOGJjLTQwYjAtODI1MC03MDdhNzgzOTc5NjkiLCJlbWFpbCI6Imdvb2RuZXNzaXJvYW55YW1haWxAZ21haWwuY29tIiwiYXVkIjpbInBheWFyZW5hLW1hbGwiLCJwYXlhcmVuYS12YXMiLCJtb2JpbGUiXSwidG9rZW5fdHlwZSI6ImlkZW50aXR5Iiwia3ljX3ZlcmlmaWVkIjp0cnVlLCJtYWxsX3Byb2ZpbGVfaWQiOm51bGwsInZhc19wcm9maWxlX2lkIjoiNzUwNWIxMjQtYWZiMC00ZjRkLWFmMDctNzI3ZDE4NWRmMDAzIiwid2FsbGV0X2FjY291bnRfbnVtYmVyIjoiMDUyMDAwNzQzNCIsImNoYW5uZWwiOiJtb2JpbGUiLCJqdGkiOiJmY2M0MjhiZC1kNzE5LTQyZjgtODVlZS01ZmY2NTk1NmVmMzIiLCJpYXQiOjE3OTM2Mzc5NzIsImV4cCI6MTc5MzYzODg3Mn0.I71v7HxTEKig0NFjVyQpZVTXPFGxGRHL7cyjO5xmeNxJf9ZoeBsKdC7CUUaEpQX208OTZ2MildiN5j6kzoNLhTMyrS5FQo-hH_MN0g48S83HUSyfJ2TBWutswukLzocKHC6aL95Qg-o8_YGSTtg-00pcegqNesjDY_1R07hcppBc9O8Dr6L3MX4MAvgQ1BxDHfCfFDjXLIufEZq4wLJUPlx2z0ssKGPaSNHoitEKrcb7I7PV0ik0mamBcg1QIjY9phzjdVK0Ptj_IQjAjvZ-1-n-y7jMlQNyTGq5izYJ9PLcPaWlhoKaeYtlsyNpQ8IxEcBiE5SssdDGlYIdLg4TAQ",
      //   "token2": "eyJhbGciOiJSUzI1NiIsImtpZCI6InBheWFyZW5hLWlkcC1yc2Eta2V5LXYxIiwidHlwIjoiSldUIn0.eyJpc3MiOiJodHRwczovL3Rlc3QuYXBpbWFsbC5wYXlhcmVuYS5jb20iLCJzdWIiOiJjOGFjNjlhOS1lOGJjLTQwYjAtODI1MC03MDdhNzgzOTc5NjkiLCJlbWFpbCI6Imdvb2RuZXNzaXJvYW55YW1haWxAZ21haWwuY29tIiwiYXVkIjpbInBheWFyZW5hLW1hbGwiLCJwYXlhcmVuYS12YXMiLCJtb2JpbGUiXSwidG9rZW5fdHlwZSI6ImlkZW50aXR5Iiwia3ljX3ZlcmlmaWVkIjp0cnVlLCJtYWxsX3Byb2ZpbGVfaWQiOm51bGwsInZhc19wcm9maWxlX2lkIjoiNzUwNWIxMjQtYWZiMC00ZjRkLWFmMDctNzI3ZDE4NWRmMDAzIiwid2FsbGV0X2FjY291bnRfbnVtYmVyIjoiMDUyMDAwNzQzNCIsImNoYW5uZWwiOiJtb2JpbGUiLCJqdGkiOiJmY2M0MjhiZC1kNzE5LTQyZjgtODVlZS01ZmY2NTk1NmVmMzIiLCJpYXQiOjE3OTM2Mzc5NzIsImV4cCI6MTc5MzYzODg3Mn0.I71v7HxTEKig0NFjVyQpZVTXPFGxGRHL7cyjO5xmeNxJf9ZoeBsKdC7CUUaEpQX208OTZ2MildiN5j6kzoNLhTMyrS5FQo-hH_MN0g48S83HUSyfJ2TBWutswukLzocKHC6aL95Qg-o8_YGSTtg-00pcegqNesjDY_1R07hcppBc9O8Dr6L3MX4MAvgQ1BxDHfCfFDjXLIufEZq4wLJUPlx2z0ssKGPaSNHoitEKrcb7I7PV0ik0mamBcg1QIjY9phzjdVK0Ptj_IQjAjvZ-1-n-y7jMlQNyTGq5izYJ9PLcPaWlhoKaeYtlsyNpQ8IxEcBiE5SssdDGlYIdLg4TAQ",
      //   "refresh_token": "eyJhbGciOiJSUzI1NiIsImtpZCI6InBheWFyZW5hLWlkcC1yc2Eta2V5LXYxIiwidHlwIjoiSldUIn0.eyJpc3MiOiJodHRwczovL3Rlc3QuYXBpbWFsbC5wYXlhcmVuYS5jb20iLCJzdWIiOiJjOGFjNjlhOS1lOGJjLTQwYjAtODI1MC03MDdhNzgzOTc5NjkiLCJqdGkiOiJkODA1ZWQxOS1kNWU1LTQ3YmYtOTk5Zi03YTMxOGY2YTA0ZDIiLCJ0b2tlbl90eXBlIjoicmVmcmVzaCIsImNoYW5uZWwiOiJtb2JpbGUiLCJpYXQiOjE3OTM2Mzc5NzIsImV4cCI6MTc5NjIyOTk3Mn0.MhszGX38efOz5NzbOSIaPzzR1F2dSPdvqEI79sXm_NC4VNfkGZszg1BCv_nw4C7UiEXNOmHKcKcoT0_ndow4KPe8_v61pH4vkTwm6CgvB9c2Qf69K1lahYXCtIHc4JrRisZVcdMq-6-ikiMIWUhMUh1TZ6iK-xlb8Ot7rNhEqW_6ouM03swz_WwqFRhDrh_JGmlS5YJdfjnTBeJDdy5W94v65lL_7m8tMAlJ0eaDoWdJoqeR3xFW533RcgZHwypMyfuTSnyS1T-GtqnveHxRi4-kJuOy-wUjvd4Y9Ixp9zFMXrsum-q3JXmNTnqPWMlE-IZXy7r5lHeU3zBS5yDYUw",
      //   "refreshToken": "eyJhbGciOiJSUzI1NiIsImtpZCI6InBheWFyZW5hLWlkcC1yc2Eta2V5LXYxIiwidHlwIjoiSldUIn0.eyJpc3MiOiJodHRwczovL3Rlc3QuYXBpbWFsbC5wYXlhcmVuYS5jb20iLCJzdWIiOiJjOGFjNjlhOS1lOGJjLTQwYjAtODI1MC03MDdhNzgzOTc5NjkiLCJqdGkiOiJkODA1ZWQxOS1kNWU1LTQ3YmYtOTk5Zi03YTMxOGY2YTA0ZDIiLCJ0b2tlbl90eXBlIjoicmVmcmVzaCIsImNoYW5uZWwiOiJtb2JpbGUiLCJpYXQiOjE3OTM2Mzc5NzIsImV4cCI6MTc5NjIyOTk3Mn0.MhszGX38efOz5NzbOSIaPzzR1F2dSPdvqEI79sXm_NC4VNfkGZszg1BCv_nw4C7UiEXNOmHKcKcoT0_ndow4KPe8_v61pH4vkTwm6CgvB9c2Qf69K1lahYXCtIHc4JrRisZVcdMq-6-ikiMIWUhMUh1TZ6iK-xlb8Ot7rNhEqW_6ouM03swz_WwqFRhDrh_JGmlS5YJdfjnTBeJDdy5W94v65lL_7m8tMAlJ0eaDoWdJoqeR3xFW533RcgZHwypMyfuTSnyS1T-GtqnveHxRi4-kJuOy-wUjvd4Y9Ixp9zFMXrsum-q3JXmNTnqPWMlE-IZXy7r5lHeU3zBS5yDYUw",
      //   "identity_id": "c8ac69a9-e8bc-40b0-8250-707a78397969",
      //   "identity_token": "eyJhbGciOiJSUzI1NiIsImtpZCI6InBheWFyZW5hLWlkcC1yc2Eta2V5LXYxIiwidHlwIjoiSldUIn0.eyJpc3MiOiJodHRwczovL3Rlc3QuYXBpbWFsbC5wYXlhcmVuYS5jb20iLCJzdWIiOiJjOGFjNjlhOS1lOGJjLTQwYjAtODI1MC03MDdhNzgzOTc5NjkiLCJlbWFpbCI6Imdvb2RuZXNzaXJvYW55YW1haWxAZ21haWwuY29tIiwiYXVkIjpbInBheWFyZW5hLW1hbGwiLCJwYXlhcmVuYS12YXMiLCJtb2JpbGUiXSwidG9rZW5fdHlwZSI6ImlkZW50aXR5Iiwia3ljX3ZlcmlmaWVkIjp0cnVlLCJtYWxsX3Byb2ZpbGVfaWQiOm51bGwsInZhc19wcm9maWxlX2lkIjoiNzUwNWIxMjQtYWZiMC00ZjRkLWFmMDctNzI3ZDE4NWRmMDAzIiwid2FsbGV0X2FjY291bnRfbnVtYmVyIjoiMDUyMDAwNzQzNCIsImNoYW5uZWwiOiJtb2JpbGUiLCJqdGkiOiJmY2M0MjhiZC1kNzE5LTQyZjgtODVlZS01ZmY2NTk1NmVmMzIiLCJpYXQiOjE3OTM2Mzc5NzIsImV4cCI6MTc5MzYzODg3Mn0.I71v7HxTEKig0NFjVyQpZVTXPFGxGRHL7cyjO5xmeNxJf9ZoeBsKdC7CUUaEpQX208OTZ2MildiN5j6kzoNLhTMyrS5FQo-hH_MN0g48S83HUSyfJ2TBWutswukLzocKHC6aL95Qg-o8_YGSTtg-00pcegqNesjDY_1R07hcppBc9O8Dr6L3MX4MAvgQ1BxDHfCfFDjXLIufEZq4wLJUPlx2z0ssKGPaSNHoitEKrcb7I7PV0ik0mamBcg1QIjY9phzjdVK0Ptj_IQjAjvZ-1-n-y7jMlQNyTGq5izYJ9PLcPaWlhoKaeYtlsyNpQ8IxEcBiE5SssdDGlYIdLg4TAQ",
      //   "mallResponse": {
      //     "identity_id": "c8ac69a9-e8bc-40b0-8250-707a78397969",
      //     "email": "goodnessiroanyamail@gmail.com",
      //     "first_name": "goodness",
      //     "last_name": "Iroanya",
      //     "expires_in": 900,
      //     "kyc_verified": true,
      //     "kyc_verification_url": null,
      //     "complete_profile_url": null,
      //     "email_verified": true,
      //     "is_pin_set": true,
      //     "is_pin_locked": false,
      //     "mall_profile_id": null,
      //     "vas_profile_id": "7505b124-afb0-4f4d-af07-727d185df003",
      //     "wallet_account_number": "0520007434",
      //     "wallet_account_name": "goodness Iroanya",
      //     "wallet_bank_name": "Payarena MFB",
      //     "password_update_required": false,
      //     "password_policy": {
      //       "is_compliant": true,
      //       "requires_update": false,
      //       "message": null,
      //       "errors": []
      //     }
      //   },
      // }
      if (data || paramsData.mallToken || paramsData.mallResponse) {
        let userData: any;
        try {
          const startupData = data;
          userData = startupData
            ? typeof startupData === 'string'
              ? JSON.parse(startupData)
              : startupData
            : paramsData;
        } catch (error) {
          console.error('Unable to parse mall startup data as JSON.', error);
          return;
        }

        const {
          theme,
          token,
          token2,
          refresh_token,
          refreshToken: nativeRefreshToken,
          identity_id,
          identity_token,
          mallResponse,
          mallToken,
        } = userData;

        console.info('[Parent] Mall startup params received:', {
          hasMallToken: Boolean(mallToken),
          hasMallResponse: Boolean(mallResponse),
        });

        this.utils.setTheme(theme);
        if (token || identity_token) {
          localStorage.setItem(this.utils.STORAGE_KEYS.TOKEN, token || identity_token);
        }
        // token2 is kept for compatibility with the current native payload.
        const refreshToken = refresh_token || nativeRefreshToken || token2;
        if (refreshToken) {
          localStorage.setItem(this.utils.STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
        }
        if (identity_id) {
          localStorage.setItem(this.utils.STORAGE_KEYS.IDENTITY_ID, identity_id);
        }
        if (identity_token) {
          localStorage.setItem(this.utils.STORAGE_KEYS.IDENTITY_TOKEN, identity_token);
        }
        this.tokenRefreshService.restart();

        if (mallToken && mallResponse) {
          this.setMallToken(mallToken);
          let parsedMallResponse = mallResponse;
          if (typeof mallResponse === 'string') {
            try {
              parsedMallResponse = JSON.parse(mallResponse);
            } catch {
              // Keep plain string user data as-is.
            }
          }
          this.setMallUserInfo(parsedMallResponse);
          this.notifyParentUpdate(); // Notify parent after successful login
          this.sendToIframe();
        }
      }
    });
  }

  //aderorhoeugene@gmail.com
  //@Genius43

  // authenticateMallUser(email: string, password: string) {
  //   console.log('Mall login with:', {
  //     email: 'leyeshalom@gmail.com',
  //     password: 'Shalom17.',
  //   });
  //   this.mallAuthService.login({ email, password }).subscribe({
  //     next: () => console.log('Mall access has been authorized'),
  //     error: (err) => console.error('Mall login failed', err),
  //   });
  // }

  public getMallToken(): string | null {
    return localStorage.getItem(this.utils.STORAGE_KEYS.MALL_TOKEN);
  }

  notifyParentUpdate() {
    // Only send if running in an iframe
    if (window !== window.parent) {
      // const targetOrigin =
      //   window.location.hostname === 'localhost'
      //     ? 'http://localhost:3000'
      //     : 'https://digital.payarena.com';
      const hostname = window.location.hostname;

      // Define allowed origins
      // // let targetOrigin = 'https://digital.payarena.com'; // Default fallback
      // let targetOrigin = 'https://test.mall.payarena.com';
      let targetOrigin = 'https://mall.payarena.com';
      if (hostname === 'localhost') {
        targetOrigin = 'http://localhost:3000';
      } else if (
        hostname === 'test.digital.payarena.com' ||
        hostname === 'digital.payarena.com'
      ) {
        targetOrigin = `https://${hostname}`;
      }
      const data = {
        [this.utils.STORAGE_KEYS.MALL_TOKEN]: this.getMallToken(),
        [this.utils.STORAGE_KEYS.MALL_USER_INFO]: localStorage.getItem(
          this.utils.STORAGE_KEYS.MALL_USER_INFO,
        ),
        ionic: JSON.parse(localStorage.getItem('ionic') || 'false'),
      };
      console.log(
        '🚀 [MallAuth] Sending UPDATE_LOCAL_STORAGE to parent:',
        targetOrigin,
        data,
      );
      window.parent.postMessage(
        {
          type: 'UPDATE_LOCAL_STORAGE',
          data,
        },
        targetOrigin,
      );
    }
  }

  private isCreateWalletNavigation(event: any): boolean {
    if (event instanceof NavigationStart) {
      return event.url.includes('/create-wallet');
    }
    return false;
  }

  private setMallToken(token: string): void {
    localStorage.setItem(this.utils.STORAGE_KEYS.MALL_TOKEN, token);
  }

  private setMallUserInfo(userInfo: any): void {
    localStorage.setItem(
      this.utils.STORAGE_KEYS.MALL_USER_INFO,
      JSON.stringify(userInfo),
    );
  }

  private sendToIframe() {
    if (this.mallIframeWindow && this.mallIframeOrigin) {
      this.sendLocalStorageToIframe(
        this.mallIframeWindow,
        this.mallIframeOrigin,
      );
      return;
    }

    const iframe = document.querySelector('iframe');
    if (iframe && iframe.contentWindow) {
      const targetOrigin = new URL(iframe.src).origin;
      const localStorageData = {
        [this.utils.STORAGE_KEYS.MALL_TOKEN]:
          this.getMallToken() ||
          localStorage.getItem('mall-token') ||
          localStorage.getItem('token'),
        [this.utils.STORAGE_KEYS.MALL_USER_INFO]:
          localStorage.getItem(this.utils.STORAGE_KEYS.MALL_USER_INFO) ||
          localStorage.getItem('mallUserInfo'),
      };
      iframe.contentWindow.postMessage(
        {
          type: 'SYNC_LOCAL_STORAGE',
          data: localStorageData,
        },
        targetOrigin,
      );
      console.log('✅ Sent to iframe from auth service:', {
        hasMallToken: Boolean(localStorageData[this.utils.STORAGE_KEYS.MALL_TOKEN]),
        hasMallUserInfo: Boolean(localStorageData[this.utils.STORAGE_KEYS.MALL_USER_INFO]),
      });
    } else {
      console.warn('⚠️ No iframe found or contentWindow not accessible');
    }
  }
}
